import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { IntlBlock } from '@sola/ark-core/atoms/intl/Intl.tsx';
import { Alert } from '@sola/ark-core/molecules/alert/alert.tsx';
import { ErrorCart } from '@sola/schema/dotcom/cart/errors.ts';
import { ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { trackError } from '@sola/tracking/components/datalayer.tsx';

// TODO: Refactor to use for other calls to add items to the cart?
const BioErrors: React.FC<{
  errors: ErrorCart[];
}> = t0 => {
  const $ = _c(12);
  const {
    errors
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["bio", "checkout", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t,
    i18n
  } = useTranslation(t1);
  let t2;
  let t3;
  if ($[1] !== errors || $[2] !== i18n || $[3] !== t) {
    const errorTypesDisplayed = [];
    const errorsToDisplay = errors.reduce((displayErrors, err) => {
      if (!errorTypesDisplayed.includes(err.type)) {
        errorTypesDisplayed.push(err.type);
        return [...displayErrors, err];
      }
      return displayErrors;
    }, []);
    t2 = "flex flex-col gap-y-snug-xl mb-comfy-xl";
    let t4;
    if ($[6] !== i18n || $[7] !== t) {
      t4 = error => {
        trackError(JSON.stringify(error));
        const {
          type,
          severity
        } = error;
        const elKey = error.id;
        const hasMsg = i18n.exists(`checkout:errors.${type}.message`);
        const hasTitle = i18n.exists(`checkout:errors.${type}.title`);
        const message = hasMsg ? <IntlBlock i18nKey={`checkout:errors.${type}.message`} values={error} tOptions={{
          interpolation: {
            escapeValue: false
          }
        }} components={{
          anchor: <a />
        }} /> : t("checkout:errors.CART_GENERIC.message");
        const title = hasTitle ? <IntlBlock i18nKey={`checkout:errors.${type}.title`} values={error} tOptions={{
          interpolation: {
            escapeValue: false
          }
        }} /> : undefined;
        return (hasMsg || hasTitle) && <Alert key={elKey} variant={severity ?? "negative"} title={hasTitle && title} message={hasMsg && message} dismissible={false} />;
      };
      $[6] = i18n;
      $[7] = t;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = errorsToDisplay.map(t4);
    $[1] = errors;
    $[2] = i18n;
    $[3] = t;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export const SubmitButton = t0 => {
  const $ = _c(22);
  const {
    bioErrors,
    className,
    details,
    isSubmitting,
    handleSponsorshipSubmit
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["bio"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== bioErrors) {
    t2 = bioErrors && <BioErrors errors={bioErrors} />;
    $[1] = bioErrors;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] !== handleSponsorshipSubmit || $[4] !== isSubmitting) {
    t3 = () => {
      if (!isSubmitting) {
        handleSponsorshipSubmit();
      }
    };
    t4 = () => {
      if (!isSubmitting) {
        handleSponsorshipSubmit();
      }
    };
    $[3] = handleSponsorshipSubmit;
    $[4] = isSubmitting;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== details || $[8] !== isSubmitting || $[9] !== t) {
    t5 = isSubmitting ? `${t("bio:processing")}...` : t("bio:sponsorButton", {
      childName: details.name.preferred,
      koreanName: details.hangul.preferred || details.name.preferred,
      interpolation: {
        escapeValue: false
      }
    });
    $[7] = details;
    $[8] = isSubmitting;
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <button id="add-cdsp" className="w-full md:w-fit" type="button" onPointerUp={t3} onClick={t4}>{t5}</button>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== isSubmitting || $[16] !== t6) {
    t7 = <ButtonStyle variant="primary" isBusy={isSubmitting}>{t6}</ButtonStyle>;
    $[15] = isSubmitting;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== className || $[19] !== t2 || $[20] !== t7) {
    t8 = <div className={className}>{t2}{t7}</div>;
    $[18] = className;
    $[19] = t2;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};